import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

const accountSchema = yup.object().shape({
  groupName: yup.string().nullable().optional(),
  code: yup.string().nullable().optional(),
  account: yup.string().nullable().optional(),
  periodName: yup.string().nullable().optional(),
  periodSortValue: yup.string().nullable().optional(),
  periodRevenue: yup.string().nullable().optional(),
})

const additionalFeeSchema = yup.object().shape({
  name: yup.string().nullable().optional(),
  amount: yup.string().nullable().optional(),
})

export const incomeStatementXlsxFileDataSchema = yup.object().shape({
  title: yup.string().nullable().optional(),
  description: yup.string().nullable().optional(),
  periodEnd: yup.string().nullable().optional(),
  revenueAccounts: yup.array().of(accountSchema).required(),
  costAccounts: yup.array().of(accountSchema).required(),
  operatingExpenseAccounts: yup.array().of(accountSchema).required(),
  otherAccounts: yup.array().of(accountSchema).required(),
  additionalFees: yup.array().of(additionalFeeSchema).required(),
})

export type IncomeStatementXlsxFileData = yup.InferType<typeof incomeStatementXlsxFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<IncomeStatementXlsxFileData>

export const incomeStatementXlsxFileMappings: RequiredFileData = {
  title: 'd4a1d3e7-3e8d-4f39-9f3f-4a7cfd3892d1',
  description: 'e3b3ef82-61c3-4a65-9e8e-237f5a8d1d02',
  periodEnd: 'f7c9f3e1-28b2-4d60-8a75-87e8c8e4a5a6',
  revenueAccounts: [
    {
      groupName: '9e4d3c70-4f2a-41d8-8c95-3bde9c6b7f85',
      code: 'b7fa1e67-61b3-4e4f-bd8e-2f5c7c7e8912',
      account: 'f6240b1b-c51c-44a9-a59e-a91241ac422d',
      periodName: 'c4d2c3f0-19ab-4e7c-9c1d-5f86d6f4e3b1',
      periodSortValue: 'fbdf763c-14c4-4833-881f-a4cd373b7a71',
      periodRevenue: 'a8f5e9c1-6d7b-4c2e-93f3-7a5e6c2d8f10',
    },
  ],
  costAccounts: [
    {
      groupName: '158243bf-7f8c-4039-939b-1749b58901e1',
      code: 'a81fa606-cd82-4a11-bdd8-9cafb5fe6c51',
      account: 'aec105d3-4918-45d1-b3da-1bd1474dadc7',
      periodName: 'da286e67-29df-4fac-a964-8a8e4edafc82',
      periodSortValue: 'af80d066-fe71-4fe7-abc4-a65c87cecbe3',
      periodRevenue: 'd5076a88-80c5-48ca-9944-6b3e73da464e',
    },
  ],
  operatingExpenseAccounts: [
    {
      groupName: '8e1e4a6e-277b-4ca6-a604-6bf4fda88e79',
      code: 'f7542f6a-1994-46e0-b9e2-3c333a0d43b4',
      account: 'df4bebf5-dc26-476a-91e1-8e98a6112bba',
      periodName: 'c40d3950-d718-4966-ab64-97519679161d',
      periodSortValue: '2b09fa5f-bd95-4c60-ac7a-0c94f096675b',
      periodRevenue: '72233408-4ade-438f-a86c-4b01d4a3bb45',
    },
  ],
  otherAccounts: [
    {
      groupName: 'baa92ae8-fffa-48c0-8cfb-bdad17f31736',
      code: '9fc32541-bf0b-461f-971b-ad53e9afe133',
      account: 'f141a1fa-3e20-4740-832e-273d82c81335',
      periodName: 'febbb469-e9b3-4be7-9456-8eceac610f2a',
      periodSortValue: '434b68f7-0aa2-485f-9849-676ad0c4594b',
      periodRevenue: 'e105c353-5fee-4998-a2c2-e0c8d33ef391',
    },
  ],
  additionalFees: [
    {
      name: '7a52a739-9991-4cf1-9b35-76112c762252',
      amount: 'e2f6a9b0-8b4d-47a7-bda9-3c2f1d4e6f78',
    },
  ],
}
